import React from 'react';
import {MaterialTableComponent} from "@components/form/MaterialTableComponent";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import {ProductPricesContainer} from "@components/product/modals/new-product/product-prices.container";
import withStyles from '@material-ui/core/styles/withStyles';
import list from '@style/list';
import { Products } from "@components/product";
import { connect } from 'react-redux';

class PricesTable extends React.Component {

    render() {
        const { onSubmit, groups } = this.props;

        let prices = this.props.prices.filter((row) => {return row.group?.is_default == false})

        return (<MaterialTableComponent
            data={prices}
            columns={[
                {
                    title: 'Группа цен',
                    field: 'group.title',
                    hideMobileTitle: true,
                    render: row => row.group ? row.group.title : groups.length !== 0 ? groups.filter(group => group.value == row.group_id)[0].label : '',
                    mobileRender: (row, rowIndex) => <Grid container style={{padding: '20px 10px 10px'}}>
                        <Grid item xs={6}>
                            <Typography variant={'body2'}>Группа цен</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant={'body2'}>{row.group ? row.group.title : groups.length !== 0 ? groups.filter(group => group.value == row.group_id)[0].label : ''}</Typography>
                        </Grid>
                    </Grid>
                },
                {
                    title: 'Цена',
                    field: 'price',
                    hideMobileTitle: true,
                    render: row => parseFloat(row.price).toFixed(2),
                    mobileRender: (row, rowIndex) => <Grid container style={{padding: '10px'}}>
                        <Grid item xs={6}>
                            <Typography variant={'body2'}>Цена</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant={'body2'}>{parseFloat(row.price).toFixed(2)}</Typography>
                        </Grid>
                    </Grid>
                },
            ]}
            actions={[
                {
                    icon: (row, index) => <ProductPricesContainer
                        onSubmit={onSubmit}
                        data={row}
                        priceGroupId={!!row.id ? row.id : row}
                        price_groups={groups}
                    />,
                    onClick: () => true,
                },
            ]}
        />);
    }
}

const mapStateToProps = (state, props) => ({});

const actions = {
    getPriceGroups: Products.actions.getPriceGroups,
};

export const PricesTableComponent = connect(mapStateToProps, actions)(withStyles(list)(PricesTable));
